<template>
    <section id="past-campaign" class="step-content-slot">
        <div class="wizard-component container">
            <Heading
                title="Add your campaign to the platform"
                description= 'Paste the link of your Kickstarter campaign and click "Next"'
            />
            <div class="wizard-content mt-4">
                <div class="row">
                    <div class="col-8">
                        <div class="link-banner position-relative">
                            <!-- if want to return last changes, just uncomment this part -->

                            <!-- <p class="lab c6 mb-0">Search By Title</p>
                            <div class="position-relative">
                                <input
                                        v-model="scrapeLink"
                                        type="text"
                                        placeholder="Find your Kickstarter campaign by Title"
                                        class="w-100 p1n mt-1 form-field"
                                        @keyup="elasticSearch"
                                        ref="scrapeLinkRef">
                                <WizardInputIcon class="wizard-input-icon"/>
                            </div>
                            <p
                                v-if="documentExists"
                                class="lab text-danger mb-0">
                                The campaign already is on the platform
                            </p>
                            <p
                                v-if="result !== null && !result.length"
                                class="lab text-danger mb-0">
                                We couldn’t find your campaign by Title. Paste the direct URL and click “Next”.
                            </p>
                            <ul class="m-0 p-0">
                                <li
                                    v-for="(item,index) in result"
                                    :key="`camp_title-${index}`"
                                    class="mt-1 p1b pl-3"
                                    @click="load(item)">
                                    {{item._source.title}}
                                </li>
                            </ul> -->
                            <div class="pt-3">
                                <!-- if want to return last changes, just uncomment this part and remove next line <div>-->
                                <!-- <div v-if="showUrlField"> -->
                                <div>
                                    <!-- <p class="lab c6 mb-0">Paste the link of your Kickstarter campaign and click “Next”</p> -->
                                    <div class="position-relative">
                                        <input
                                            id="url-input"
                                            v-model="urlText"
                                            @paste="loadFromKickstarter($event)"
                                            @keyup.enter="loadFromKickstarter"
                                            :class="{'ready': isReady && !loading && urlText && urlText.length}"
                                            type="text"
                                            class="w-100 p1n mt-1 form-field"
                                            ref="urlLink">
                                        <WizardUrlIcon class="wizard-url-icon"/>
                                        <WizardSearchIcon
                                            id="search-by-url"
                                            :active="active"
                                            @click.native="loadFromKickstarter"
                                            class="wizard-search-icon"/>
                                    </div>
                                </div>
                                <!-- if want to return last changes, just uncomment this part -->
                                <!-- <p
                                    v-else
                                    @click="showUrlInput"
                                    class="c1 p1n underlined_links mt-1 mb-0">
                                    Or by URL
                                </p> -->
                                <!-- <p v-if="urlText && !urlText.includes('kickstarter.com')" id="err-text" class="lab c5">Only kickstarter.com links are allowed</p> -->
                                <p v-if="loading">Loading...</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { addData, getData, updateData, uploadImage } from '../../firebaseCRUD';
    import { kickstarterLoad, DEFAULT_CAMPAIGN_COLLECTION } from "../../firebase";
    import { message } from 'ant-design-vue'
    import axios from 'axios'
    import { WizardSearchIcon, WizardInputIcon, WizardUrlIcon } from '../Icons'
    import Heading from "../Theme/Heading";
    import {ICON_DECLINED} from "../../constants";
    import alerts from '../../core/utils/messages.utils'
    import {Archives, Drafts, Campaigns} from '../../core/services/campaigns.service'

    export default {
        name: "AddCampaign",
        components: {
            WizardSearchIcon,
            WizardInputIcon,
            WizardUrlIcon,
            Heading
        },
        props: {
            cardData: Object,
        },
        data() {
            return {
                authUserUid: this.$store.state.user.uid,
                result: null,
                scrapeLink: '',
                timeout: undefined,
                documentExists: false,
                urlText: null,
                showUrlField: false,
                loading: false,
                active: false,
                disabledField: false,
                isReady: false,
                ICON_DECLINED
            }
        },
        watch: {
            'urlText': function(val) {
                this.active = val && val.length > 0 && val.includes('kickstarter.com')
            },
            '$route.query': function(val) {
                if(!val.id) {
                    this.resetStepForm();
                }
            },
        },
        mounted: function () {

            this.$nextTick(() => {
                if(this.$refs.scrapeLinkRef){
                    this.$refs.scrapeLinkRef.focus()
                }
            })

            // reset all existing data in "Add new campaign" view
            if (!this.$route.query.id) {
                this.resetStepForm();
            } else {
                this.$router.push('/wizard/edit-campaign?id='+this.$route.query.id).catch(() => {}) 
            }
        },
        methods: {
            // showUrlInput(){
            //     this.showUrlField = true;
            // },
            resetStepForm(){
                this.scrapeLink = '';
                this.$emit('resetData');
                this.disabledField = false;
                this.$emit('disableNext', true);
            },
            elasticSearch: function () {
                if(!this.scrapeLink || this.scrapeLink && !this.scrapeLink.length){
                    this.$emit('disableNext', true)
                    return;
                }
                if (this.timeout) {
                    clearTimeout(this.timeout)
                }
                this.timeout = setTimeout(
                    async () => {
                        try {
                            const response = await axios({
                                method: 'POST',
                                url: 'https://search.crossprom.com/campaigns/_search',
                                data: {
                                    from: 0,
                                    size: 5,
                                    query: {
                                        bool: {
                                            must: [
                                                {
                                                    query_string: {
                                                        fields: ['title'],
                                                        query: `*${this.scrapeLink.replace(/:/gi, '')}*`
                                                    }
                                                },
                                                {
                                                    terms: {
                                                        platform: ['kickstarter'],
                                                    }
                                                },
                                            ]
                                        }
                                    }
                                }


                            })
                            this.result = response.data.hits.hits

                            if (this.scrapeLink === '') {
                                this.scrapeLink = null
                                this.result =null
                                this.$emit('resetData');
                                this.documentExists = false
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }, 500
                )
            },
            async loadFromKickstarter(event) {

                // preventing doubled url
                setTimeout(async ()=> {

                    // using clipboardData text if url is pasted	
                    if(!this.urlText) {
                        this.urlText = event && event.clipboardData ? event.clipboardData.getData('text') : '';	
                    }

                    if(!this.urlText) {
                        return
                    }

                    if(!this.urlText || this.urlText && !this.urlText.includes('kickstarter.com')) {	
                        return message.error(alerts.NOT_KICKSTARTER_URL)
                    }	
                    if (this.urlText.split('/').length > 6) {	
                        return message.error(alerts.INVALID_URL)	
                    }

                    this.loading = true
                    let ksData = {}

                    try {
                        const {data}  = await kickstarterLoad({ url: this.urlText });
                        if (!data) {
                            this.isReady = false
                            return message.error(alerts.NOT_FOUND)
                        }

                        // if(!event.target.value) {
                        //     event.target.value = urlText
                        // }
                        if(!data.title) {
                            return message.error(`
                                It seems your campaign is not yet available for public. 
                                Please add it once it's not in private beta stage anymore.
                            `)
                        }

                        ksData = {
                            id: data.elastic_id || 'kickstarter-id',
                            ...data
                        }

                        const [existingCampaign, exisitingArchive, existingDraft] =  await Promise.all([
                            Campaigns.where('title', '==', data.title).get(),
                            Archives.where('title', '==', data.title).get(),
                            Drafts.where('title', '==', data.title).get(),
                        ])

                        // check for an existing campaign or archive
                        if (!existingCampaign.empty || !exisitingArchive.empty) {
                            this.isReady = false
                            return message.error(alerts.ALREADY_REGISTERED, 3)
                        }

                        // check for an existing draft
                        if(!existingDraft.empty) {
                            this.isReady = false
                            return message.error(alerts.IS_IN_DRAFTS, 5)
                        }

                        this.documentExists = false;
                        this.$emit('disableNext', false);
                        this.$emit('setData', {...ksData, project_id: ksData.id});
                        this.result = null;
                        this.$emit('setChildEvent', {
                            next: this.sendDataToFirebase
                        });
                        this.isReady = true
                        this.$ga.event('Add Wizard', 'Paste KS URL', `
                            FoundCampaign: ${data.title},
                            Step: 1
                        `)
                        this.$sendMixpanelEvent('Add Wizard', {
                            'Step Number': 1,
                            'Action': 'Paste KS URL',
                            'Found Campaign': data.title
                        });
                    } catch (e) {
                        this.isReady = false
                        message.error(alerts.NOT_FOUND)
                        console.log(e)
                    } finally {
                        this.loading = false
                    }
                }, 100)

                
            },
            async sendDataToFirebase() {
                const daysToGo = this.cardData.days_to_go || this.cardData.daystogo || 0;
                const data = {
                    author_id: this.authUserUid,
                    project_id: this.cardData.project_id,
                    project_url: this.cardData.project_url,
                    title: this.cardData.title,
                    description: this.cardData.description,
                    category: this.cardData.category,
                    state: this.cardData.state,
                    tags: this.cardData.tags || [],
                    image: this.cardData.image,
                    currency: this.cardData.currency || null,
                    money_amount: this.cardData.money_amount || 0,
                    daystogo: daysToGo,
                    platform: this.cardData.platform,
                    backers: this.cardData.backers || 0,
                    wizard_step: 0,
                    created_at: new Date()
                }

                try {
                    const docRef = await addData({
                        collection: DEFAULT_CAMPAIGN_COLLECTION,
                        data
                    })

                    this.$emit('setData', { ...this.cardData, docId: docRef.id });

                    this.$router.replace({
                        query: {
                            ...this.$route.query,
                            id: docRef.id,
                            model: DEFAULT_CAMPAIGN_COLLECTION
                        }
                    }).catch(() => console.log(e));
                } catch (e) {
                    console.log(e);
                }
            },
            load: async function (item) {
                try {
                    // const snap  = await getData( DEFAULT_CAMPAIGN_COLLECTION, {
                    //     field: 'project_id',
                    //     condition: '==',
                    //     value: item._id
                    // });
                    // for test
                    const snap  = await getData( 'campaigns', {
                        field: 'project_id',
                        condition: '==',
                        value: item._id
                    });


                    if (snap.docs.length) {
                        this.documentExists = true
                        return
                    }

                    this.documentExists = false

                    this.$emit('setData', {
                        ...item._source,
                        project_id: item._id,
                    });
                    this.$emit('disableNext', false);
                    this.disabledField = true;
                    this.scrapeLink = item._source.title
                    this.result = null
                    this.$emit('setChildEvent', {
                        next: this.sendDataToFirebase
                    });
                } catch(e) {
                    this.$store.dispatch('handleErrors', e)
                }

            },
        },
    }
</script>

<style scoped lang="scss">
    .link-banner {
        ul {
            background: #00000045;
            border-radius: 5px;
            width: 100%;
            z-index: 1000;

            li {
                color: #ffffff;
                transition: all 0.2s ease-in;
                cursor: pointer;

                &:hover {
                    background: #98a6adb3;
                }
            }
        }
        input {
            box-sizing: border-box;
            height: 34px;
            padding-left: 30px!important;
            padding-right: 30px;

        }
        svg {
            &.wizard-input-icon,
            &.wizard-search-icon,
            &.wizard-url-icon
            {
                position: absolute;
                top: 50%;
                transform: translateY(-44%);
            }
            &.wizard-input-icon {
                left: 2px;
            }
            &.wizard-search-icon {
                right: 10px;
            }
            &.wizard-url-icon {
                left: 2px;
            }
        }
    }

    .link-banner img {
        top: 0;
        left: 100%;
        transform: translate(20px, 1px);
    }

    .ready {
        border: 1px solid #0ACF97 !important;
        box-shadow: 0px 0px 4px 0px #0ACF97;
    }
</style>